import React, { FunctionComponent } from 'react'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'

type AutoplayIconProps = {
    autoplay: boolean
    onPress: () => void
}

export const AutoplayIcon: FunctionComponent<AutoplayIconProps> = ({ autoplay, onPress }) => {
    return (
        <Grid zIndex={5} position="absolute" right={0}>
            <Touchable onPress={onPress}>
                <Grid
                    noExpand
                    borderRadius={20}
                    backgroundColor="onyx-opacity-50"
                    margin={4}
                    padding={2}
                >
                    <FontelloIcon name={`autoplay${autoplay ? '' : '-off'}`} color="WHITE" />
                </Grid>
            </Touchable>
        </Grid>
    )
}
